/**
 * @flow
 */

import React from 'react';
import styled from 'styled-components';
import Avatar from './Avatar';

type MasterTypeIconProps = {
    type: string,
} & Avatar;

const icons = {
    hairdresser: '/svg/icon-hairdresser.svg',
    cosmetologist: '/svg/icon-cosmetologist.svg',
    manicure: '/svg/icon-manicure.svg',
};

const Icon = styled(Avatar)`
    flex: 0 0 auto;
    overflow: hidden;
    vertical-align: middle;
    img {
        max-width: unset !important;
    }
`;

const EmptyIcon = styled.div`
    display: inline-block;
    width: 24px;
    margin-right: 0.5em;
`;

function MasterTypeIcon({ type, ...avatarProps }: MasterTypeIconProps) {
    const icon = icons[String(type).toLowerCase()];

    if (!icon) {
        return <EmptyIcon />;
    }

    return (
        <Icon
            src={icon}
            size={24}
            spaced="right"
            round
            {...avatarProps}
        />
    );
}

export default MasterTypeIcon;
